// manage-product-group.component.ts
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AdminCommonHttpService } from '../service/admin-common-http.service';
import { ProductGroup, ProductGroupService } from '../service/product-group.service';
import { MatOption } from '@angular/material/core';


@Component({
  selector: 'app-manage-product-group',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatOption
  ],
  templateUrl: './manage-product-group.component.html',
  styleUrl: './manage-product-group.component.scss'
})
export class ManageProductGroupComponent implements OnInit {
  productGroups: ProductGroup[] = [];
  newGroup: Partial<ProductGroup> = {};
  editingGroup: ProductGroup | null = null;
  products: { product_id: number; name: string }[] = [];
  selectedGroupId: string | null = null;
  selectedProductIds: number[] = [];
  groupProducts: any[] = [];


  constructor(
    private commonApiService: AdminCommonHttpService,
    private snackBar: MatSnackBar,
    private manageGroupService: ProductGroupService
  ) { }

  async ngOnInit(): Promise<void> {
    await this.loadGroups();
    await this.loadAllProducts();
  }

  async loadAllProducts(): Promise<void> {
    this.products = await this.commonApiService.getAllProductsNoPagination();
  }


  async loadGroups(): Promise<void> {
    this.productGroups = await this.manageGroupService.getAllGroups();
  }

  async createGroup(): Promise<void> {
    if (!this.newGroup.name) return;
    await this.manageGroupService.createGroup({
      name: this.newGroup.name!,
      description: this.newGroup.description
    });

    this.newGroup = {};
    await this.loadGroups();
    this.snackBar.open('Product group created', 'Close', { duration: 3000 });
  }

  editGroup(group: ProductGroup): void {
    this.editingGroup = { ...group };
  }

  async updateGroup(): Promise<void> {
    if (!this.editingGroup?.id) return;
    await this.manageGroupService.updateGroup(this.editingGroup.id, this.editingGroup);
    this.editingGroup = null;
    await this.loadGroups();
    this.snackBar.open('Product group updated', 'Close', { duration: 3000 });
  }

  async deleteGroup(id: string): Promise<void> {
    await this.manageGroupService.deleteGroup(id);
    await this.loadGroups();
    this.snackBar.open('Product group deleted', 'Close', { duration: 3000 });
  }

  cancelEdit(): void {
    this.editingGroup = null;
  }

  async assignProductsToGroup(): Promise<void> {
    if (!this.selectedGroupId || this.selectedProductIds.length === 0) return;

    await this.manageGroupService.assignProductsToGroup(this.selectedGroupId, this.selectedProductIds);
    this.snackBar.open('Products assigned successfully', 'Close', { duration: 3000 });

    this.selectedProductIds = [];
    await this.viewProductsInGroup(this.selectedGroupId); // refresh list
  }

  async viewProductsInGroup(groupId: string): Promise<void> {
    this.selectedGroupId = groupId;
    this.groupProducts = await this.manageGroupService.getProductsInGroup(groupId);
  }

}
